import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHttpClient } from '../global.http.client';
import { BaseService } from './base.service';
import { CreateSubscriptionDto, CardSubscriptionDto, CreateStripePaymentIntentDto } from '../models/subscriptions/subscription.models';
import { SubscriptionSearchModel, SubscriptionSummaryDto } from '../models/subscriptions/subscription.search.models';
import { ISearchService } from './search.service';
import { IPage } from '../models/common/paging';
import { Configuration } from '../configuration';
import { LoggedInUserService } from '../auth/logged.in.user';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class SubscriptionService extends BaseService implements ISearchService<SubscriptionSearchModel,
SubscriptionSummaryDto> {
    constructor(http: GlobalHttpClient, private config: Configuration, private loggedInUserService: LoggedInUserService) {
        super(http);
    }

    getAccountTypes() {
        var response = this.http.get('subscriptions/getAccountTypes');

        return response;
    }

    subscribe(request: CreateSubscriptionDto) {
        var response = this.http.post('subscriptions/subscribe', request);

        return response;
    }

    subscribeWithCard(request: CardSubscriptionDto) {
        var response = this.http.post('subscriptions/subscribeWithCard', request);

        return response;
    }

    takeStripePayment(sourceId: string) {
        var response = this.http.post('payments/takeStripePayment', { sourceId: sourceId });

        return response;
    }

    createPaymentIntent(request: CreateStripePaymentIntentDto) {
        var response = this.http.post('subscriptions/createPaymentIntent', request);

        return response;
    }

    search(request: SubscriptionSearchModel): Observable<IPage<SubscriptionSummaryDto>> {
        return this.http.getWithParams<IPage<SubscriptionSummaryDto>>('subscriptions/subscriptions', request);
    }

    downloadInvoice(id: number) {
        const invWindow = window.open();

        this.http.get(`subscriptions/invoiceToken/${id}`).subscribe((response: any) => {
            var token = response.token;

            var res = encodeURIComponent(encodeURIComponent(encodeURIComponent(token)));

            var url = `${this.config.routing.api.baseUrl}/subscriptions/invoice/${res}`;

            invWindow.location.href = url;
        });
    }

    downloadPayment(id: number) {

        const invWindow = window.open();

        this.http.get(`subscriptions/paymentToken/${id}`).subscribe((response: any) => {
            var token = response.token;

            var res = encodeURIComponent(encodeURIComponent(token));

            var url = `${this.config.routing.api.baseUrl}/subscriptions/paymentReceipt/${res}`;

            invWindow.location.href = url;
        });
    }

    getSubscriptionInfo(id: number) {
        return this.http.get(`subscriptions/info/${id}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/subscription.service.ts